(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["notepack"] = factory();
	else
		root["notepack"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	exports.encode = __webpack_require__(1);
	exports.decode = __webpack_require__(2);


/***/ }),
/* 1 */
/***/ (function(module, exports) {

	'use strict';
	
	function utf8Write(view, offset, str) {
	  var c = 0;
	  for (var i = 0, l = str.length; i < l; i++) {
	    c = str.charCodeAt(i);
	    if (c < 0x80) {
	      view.setUint8(offset++, c);
	    }
	    else if (c < 0x800) {
	      view.setUint8(offset++, 0xc0 | (c >> 6));
	      view.setUint8(offset++, 0x80 | (c & 0x3f));
	    }
	    else if (c < 0xd800 || c >= 0xe000) {
	      view.setUint8(offset++, 0xe0 | (c >> 12));
	      view.setUint8(offset++, 0x80 | (c >> 6) & 0x3f);
	      view.setUint8(offset++, 0x80 | (c & 0x3f));
	    }
	    else {
	      i++;
	      c = 0x10000 + (((c & 0x3ff) << 10) | (str.charCodeAt(i) & 0x3ff));
	      view.setUint8(offset++, 0xf0 | (c >> 18));
	      view.setUint8(offset++, 0x80 | (c >> 12) & 0x3f);
	      view.setUint8(offset++, 0x80 | (c >> 6) & 0x3f);
	      view.setUint8(offset++, 0x80 | (c & 0x3f));
	    }
	  }
	}
	
	function utf8Length(str) {
	  var c = 0, length = 0;
	  for (var i = 0, l = str.length; i < l; i++) {
	    c = str.charCodeAt(i);
	    if (c < 0x80) {
	      length += 1;
	    }
	    else if (c < 0x800) {
	      length += 2;
	    }
	    else if (c < 0xd800 || c >= 0xe000) {
	      length += 3;
	    }
	    else {
	      i++;
	      length += 4;
	    }
	  }
	  return length;
	}
	
	function _encode(bytes, defers, value) {
	  var type = typeof value, i = 0, l = 0, hi = 0, lo = 0, length = 0, size = 0;
	
	  if (type === 'string') {
	    length = utf8Length(value);
	
	    // fixstr
	    if (length < 0x20) {
	      bytes.push(length | 0xa0);
	      size = 1;
	    }
	    // str 8
	    else if (length < 0x100) {
	      bytes.push(0xd9, length);
	      size = 2;
	    }
	    // str 16
	    else if (length < 0x10000) {
	      bytes.push(0xda, length >> 8, length);
	      size = 3;
	    }
	    // str 32
	    else if (length < 0x100000000) {
	      bytes.push(0xdb, length >> 24, length >> 16, length >> 8, length);
	      size = 5;
	    } else {
	      throw new Error('String too long');
	    }
	    defers.push({ str: value, length: length, offset: bytes.length });
	    return size + length;
	  }
	  if (type === 'number') {
	    // TODO: encode to float 32?
	
	    // float 64
	    if (Math.floor(value) !== value || !isFinite(value)) {
	      bytes.push(0xcb);
	      defers.push({ float: value, length: 8, offset: bytes.length });
	      return 9;
	    }
	
	    if (value >= 0) {
	      // positive fixnum
	      if (value < 0x80) {
	        bytes.push(value);
	        return 1;
	      }
	      // uint 8
	      if (value < 0x100) {
	        bytes.push(0xcc, value);
	        return 2;
	      }
	      // uint 16
	      if (value < 0x10000) {
	        bytes.push(0xcd, value >> 8, value);
	        return 3;
	      }
	      // uint 32
	      if (value < 0x100000000) {
	        bytes.push(0xce, value >> 24, value >> 16, value >> 8, value);
	        return 5;
	      }
	      // uint 64
	      hi = (value / Math.pow(2, 32)) >> 0;
	      lo = value >>> 0;
	      bytes.push(0xcf, hi >> 24, hi >> 16, hi >> 8, hi, lo >> 24, lo >> 16, lo >> 8, lo);
	      return 9;
	    } else {
	      // negative fixnum
	      if (value >= -0x20) {
	        bytes.push(value);
	        return 1;
	      }
	      // int 8
	      if (value >= -0x80) {
	        bytes.push(0xd0, value);
	        return 2;
	      }
	      // int 16
	      if (value >= -0x8000) {
	        bytes.push(0xd1, value >> 8, value);
	        return 3;
	      }
	      // int 32
	      if (value >= -0x80000000) {
	        bytes.push(0xd2, value >> 24, value >> 16, value >> 8, value);
	        return 5;
	      }
	      // int 64
	      hi = Math.floor(value / Math.pow(2, 32));
	      lo = value >>> 0;
	      bytes.push(0xd3, hi >> 24, hi >> 16, hi >> 8, hi, lo >> 24, lo >> 16, lo >> 8, lo);
	      return 9;
	    }
	  }
	  if (type === 'object') {
	    // nil
	    if (value === null) {
	      bytes.push(0xc0);
	      return 1;
	    }
	
	    if (Array.isArray(value)) {
	      length = value.length;
	
	      // fixarray
	      if (length < 0x10) {
	        bytes.push(length | 0x90);
	        size = 1;
	      }
	      // array 16
	      else if (length < 0x10000) {
	        bytes.push(0xdc, length >> 8, length);
	        size = 3;
	      }
	      // array 32
	      else if (length < 0x100000000) {
	        bytes.push(0xdd, length >> 24, length >> 16, length >> 8, length);
	        size = 5;
	      } else {
	        throw new Error('Array too large');
	      }
	      for (i = 0; i < length; i++) {
	        size += _encode(bytes, defers, value[i]);
	      }
	      return size;
	    }
	
	    // fixext 8 / Date
	    if (value instanceof Date) {
	      var time = value.getTime();
	      hi = Math.floor(time / Math.pow(2, 32));
	      lo = time >>> 0;
	      bytes.push(0xd7, 0, hi >> 24, hi >> 16, hi >> 8, hi, lo >> 24, lo >> 16, lo >> 8, lo);
	      return 10;
	    }
	
	    if (value instanceof ArrayBuffer) {
	      length = value.byteLength;
	
	      // bin 8
	      if (length < 0x100) {
	        bytes.push(0xc4, length);
	        size = 2;
	      } else
	      // bin 16
	      if (length < 0x10000) {
	        bytes.push(0xc5, length >> 8, length);
	        size = 3;
	      } else
	      // bin 32
	      if (length < 0x100000000) {
	        bytes.push(0xc6, length >> 24, length >> 16, length >> 8, length);
	        size = 5;
	      } else {
	        throw new Error('Buffer too large');
	      }
	      defers.push({ bin: value, length: length, offset: bytes.length });
	      return size + length;
	    }
	
	    if (typeof value.toJSON === 'function') {
	      return _encode(bytes, defers, value.toJSON());
	    }
	
	    var keys = [], key = '';
	
	    var allKeys = Object.keys(value);
	    for (i = 0, l = allKeys.length; i < l; i++) {
	      key = allKeys[i];
	      if (typeof value[key] !== 'function') {
	        keys.push(key);
	      }
	    }
	    length = keys.length;
	
	    // fixmap
	    if (length < 0x10) {
	      bytes.push(length | 0x80);
	      size = 1;
	    }
	    // map 16
	    else if (length < 0x10000) {
	      bytes.push(0xde, length >> 8, length);
	      size = 3;
	    }
	    // map 32
	    else if (length < 0x100000000) {
	      bytes.push(0xdf, length >> 24, length >> 16, length >> 8, length);
	      size = 5;
	    } else {
	      throw new Error('Object too large');
	    }
	
	    for (i = 0; i < length; i++) {
	      key = keys[i];
	      size += _encode(bytes, defers, key);
	      size += _encode(bytes, defers, value[key]);
	    }
	    return size;
	  }
	  // false/true
	  if (type === 'boolean') {
	    bytes.push(value ? 0xc3 : 0xc2);
	    return 1;
	  }
	  // fixext 1 / undefined
	  if (type === 'undefined') {
	    bytes.push(0xd4, 0, 0);
	    return 3;
	  }
	  throw new Error('Could not encode');
	}
	
	function encode(value) {
	  var bytes = [];
	  var defers = [];
	  var size = _encode(bytes, defers, value);
	  var buf = new ArrayBuffer(size);
	  var view = new DataView(buf);
	
	  var deferIndex = 0;
	  var deferWritten = 0;
	  var nextOffset = -1;
	  if (defers.length > 0) {
	    nextOffset = defers[0].offset;
	  }
	
	  var defer, deferLength = 0, offset = 0;
	  for (var i = 0, l = bytes.length; i < l; i++) {
	    view.setUint8(deferWritten + i, bytes[i]);
	    if (i + 1 !== nextOffset) { continue; }
	    defer = defers[deferIndex];
	    deferLength = defer.length;
	    offset = deferWritten + nextOffset;
	    if (defer.bin) {
	      var bin = new Uint8Array(defer.bin);
	      for (var j = 0; j < deferLength; j++) {
	        view.setUint8(offset + j, bin[j]);
	      }
	    } else if (defer.str) {
	      utf8Write(view, offset, defer.str);
	    } else if (defer.float !== undefined) {
	      view.setFloat64(offset, defer.float);
	    }
	    deferIndex++;
	    deferWritten += deferLength;
	    if (defers[deferIndex]) {
	      nextOffset = defers[deferIndex].offset;
	    }
	  }
	  return buf;
	}
	
	module.exports = encode;


/***/ }),
/* 2 */
/***/ (function(module, exports) {

	'use strict';
	
	function Decoder(buffer) {
	  this.offset = 0;
	  if (buffer instanceof ArrayBuffer) {
	    this.buffer = buffer;
	    this.view = new DataView(this.buffer);
	  } else if (ArrayBuffer.isView(buffer)) {
	    this.buffer = buffer.buffer;
	    this.view = new DataView(this.buffer, buffer.byteOffset, buffer.byteLength);
	  } else {
	    throw new Error('Invalid argument');
	  }
	}
	
	function utf8Read(view, offset, length) {
	  var string = '', chr = 0;
	  for (var i = offset, end = offset + length; i < end; i++) {
	    var byte = view.getUint8(i);
	    if ((byte & 0x80) === 0x00) {
	      string += String.fromCharCode(byte);
	      continue;
	    }
	    if ((byte & 0xe0) === 0xc0) {
	      string += String.fromCharCode(
	        ((byte & 0x1f) << 6) |
	        (view.getUint8(++i) & 0x3f)
	      );
	      continue;
	    }
	    if ((byte & 0xf0) === 0xe0) {
	      string += String.fromCharCode(
	        ((byte & 0x0f) << 12) |
	        ((view.getUint8(++i) & 0x3f) << 6) |
	        ((view.getUint8(++i) & 0x3f) << 0)
	      );
	      continue;
	    }
	    if ((byte & 0xf8) === 0xf0) {
	      chr = ((byte & 0x07) << 18) |
	        ((view.getUint8(++i) & 0x3f) << 12) |
	        ((view.getUint8(++i) & 0x3f) << 6) |
	        ((view.getUint8(++i) & 0x3f) << 0);
	      if (chr >= 0x010000) { // surrogate pair
	        chr -= 0x010000;
	        string += String.fromCharCode((chr >>> 10) + 0xD800, (chr & 0x3FF) + 0xDC00);
	      } else {
	        string += String.fromCharCode(chr);
	      }
	      continue;
	    }
	    throw new Error('Invalid byte ' + byte.toString(16));
	  }
	  return string;
	}
	
	Decoder.prototype.array = function (length) {
	  var value = new Array(length);
	  for (var i = 0; i < length; i++) {
	    value[i] = this.parse();
	  }
	  return value;
	};
	
	Decoder.prototype.map = function (length) {
	  var key = '', value = {};
	  for (var i = 0; i < length; i++) {
	    key = this.parse();
	    value[key] = this.parse();
	  }
	  return value;
	};
	
	Decoder.prototype.str = function (length) {
	  var value = utf8Read(this.view, this.offset, length);
	  this.offset += length;
	  return value;
	};
	
	Decoder.prototype.bin = function (length) {
	  var value = this.buffer.slice(this.offset, this.offset + length);
	  this.offset += length;
	  return value;
	};
	
	Decoder.prototype.parse = function () {
	  var prefix = this.view.getUint8(this.offset++);
	  var value, length = 0, type = 0, hi = 0, lo = 0;
	
	  if (prefix < 0xc0) {
	    // positive fixint
	    if (prefix < 0x80) {
	      return prefix;
	    }
	    // fixmap
	    if (prefix < 0x90) {
	      return this.map(prefix & 0x0f);
	    }
	    // fixarray
	    if (prefix < 0xa0) {
	      return this.array(prefix & 0x0f);
	    }
	    // fixstr
	    return this.str(prefix & 0x1f);
	  }
	
	  // negative fixint
	  if (prefix > 0xdf) {
	    return (0xff - prefix + 1) * -1;
	  }
	
	  switch (prefix) {
	    // nil
	    case 0xc0:
	      return null;
	    // false
	    case 0xc2:
	      return false;
	    // true
	    case 0xc3:
	      return true;
	
	    // bin
	    case 0xc4:
	      length = this.view.getUint8(this.offset);
	      this.offset += 1;
	      return this.bin(length);
	    case 0xc5:
	      length = this.view.getUint16(this.offset);
	      this.offset += 2;
	      return this.bin(length);
	    case 0xc6:
	      length = this.view.getUint32(this.offset);
	      this.offset += 4;
	      return this.bin(length);
	
	    // ext
	    case 0xc7:
	      length = this.view.getUint8(this.offset);
	      type = this.view.getInt8(this.offset + 1);
	      this.offset += 2;
	      return [type, this.bin(length)];
	    case 0xc8:
	      length = this.view.getUint16(this.offset);
	      type = this.view.getInt8(this.offset + 2);
	      this.offset += 3;
	      return [type, this.bin(length)];
	    case 0xc9:
	      length = this.view.getUint32(this.offset);
	      type = this.view.getInt8(this.offset + 4);
	      this.offset += 5;
	      return [type, this.bin(length)];
	
	    // float
	    case 0xca:
	      value = this.view.getFloat32(this.offset);
	      this.offset += 4;
	      return value;
	    case 0xcb:
	      value = this.view.getFloat64(this.offset);
	      this.offset += 8;
	      return value;
	
	    // uint
	    case 0xcc:
	      value = this.view.getUint8(this.offset);
	      this.offset += 1;
	      return value;
	    case 0xcd:
	      value = this.view.getUint16(this.offset);
	      this.offset += 2;
	      return value;
	    case 0xce:
	      value = this.view.getUint32(this.offset);
	      this.offset += 4;
	      return value;
	    case 0xcf:
	      hi = this.view.getUint32(this.offset) * Math.pow(2, 32);
	      lo = this.view.getUint32(this.offset + 4);
	      this.offset += 8;
	      return hi + lo;
	
	    // int
	    case 0xd0:
	      value = this.view.getInt8(this.offset);
	      this.offset += 1;
	      return value;
	    case 0xd1:
	      value = this.view.getInt16(this.offset);
	      this.offset += 2;
	      return value;
	    case 0xd2:
	      value = this.view.getInt32(this.offset);
	      this.offset += 4;
	      return value;
	    case 0xd3:
	      hi = this.view.getInt32(this.offset) * Math.pow(2, 32);
	      lo = this.view.getUint32(this.offset + 4);
	      this.offset += 8;
	      return hi + lo;
	
	    // fixext
	    case 0xd4:
	      type = this.view.getInt8(this.offset);
	      this.offset += 1;
	      if (type === 0x00) {
	        this.offset += 1;
	        return void 0;
	      }
	      return [type, this.bin(1)];
	    case 0xd5:
	      type = this.view.getInt8(this.offset);
	      this.offset += 1;
	      return [type, this.bin(2)];
	    case 0xd6:
	      type = this.view.getInt8(this.offset);
	      this.offset += 1;
	      return [type, this.bin(4)];
	    case 0xd7:
	      type = this.view.getInt8(this.offset);
	      this.offset += 1;
	      if (type === 0x00) {
	        hi = this.view.getInt32(this.offset) * Math.pow(2, 32);
	        lo = this.view.getUint32(this.offset + 4);
	        this.offset += 8;
	        return new Date(hi + lo);
	      }
	      return [type, this.bin(8)];
	    case 0xd8:
	      type = this.view.getInt8(this.offset);
	      this.offset += 1;
	      return [type, this.bin(16)];
	
	    // str
	    case 0xd9:
	      length = this.view.getUint8(this.offset);
	      this.offset += 1;
	      return this.str(length);
	    case 0xda:
	      length = this.view.getUint16(this.offset);
	      this.offset += 2;
	      return this.str(length);
	    case 0xdb:
	      length = this.view.getUint32(this.offset);
	      this.offset += 4;
	      return this.str(length);
	
	    // array
	    case 0xdc:
	      length = this.view.getUint16(this.offset);
	      this.offset += 2;
	      return this.array(length);
	    case 0xdd:
	      length = this.view.getUint32(this.offset);
	      this.offset += 4;
	      return this.array(length);
	
	    // map
	    case 0xde:
	      length = this.view.getUint16(this.offset);
	      this.offset += 2;
	      return this.map(length);
	    case 0xdf:
	      length = this.view.getUint32(this.offset);
	      this.offset += 4;
	      return this.map(length);
	  }
	
	  throw new Error('Could not parse');
	};
	
	function decode(buffer) {
	  var decoder = new Decoder(buffer);
	  var value = decoder.parse();
	  if (decoder.offset !== buffer.byteLength) {
	    throw new Error((buffer.byteLength - decoder.offset) + ' trailing bytes');
	  }
	  return value;
	}
	
	module.exports = decode;


/***/ })
/******/ ])
});
;


// WEBPACK FOOTER //
// notepack.js